<template>
  <v-row class="ma-2">
    <v-col
      v-if="hasSyntheseAAfficher"
      cols="12"
    >
      <Synthese :loading="loading?.synthese" />
    </v-col>

    <v-col
      cols="12"
      md="4"
    >
      <RepartitionSurfaces
        :key="`surface-${dashboardKey}`"
        :annee-recolte-selected="anneeSelected"
        :code-graine-rs3-selected="codeGraineSelected"
      />
    </v-col>

    <v-col
      cols="12"
      md="4"
    >
      <RepartitionMainOeuvre
        :key="`mo-${dashboardKey}`"
        :annee-recolte-selected="anneeSelected"
        :code-graine-rs3-selected="codeGraineSelected"
      />
    </v-col>

    <v-col
      cols="12"
      md="4"
    >
      <RepartitionChiffreAffaires
        :key="`ca-${dashboardKey}`"
        :annee-recolte-selected="anneeSelected"
        :code-graine-rs3-selected="codeGraineSelected"
      />
    </v-col>

    <v-col
      cols="12"
      md="6"
    >
      <RepartitionGrandesCultures
        :key="`gc-${dashboardKey}`"
        :annee-recolte-selected="anneeSelected"
        :code-graine-rs3-selected="codeGraineSelected"
      />
    </v-col>

    <v-col
      cols="12"
      md="6"
    >
      <RepartitionChiffreAffairesParCulture
        :key="`ca-culture-${dashboardKey}`"
        :annee-recolte-selected="anneeSelected"
        :code-graine-rs3-selected="codeGraineSelected"
      />
    </v-col>

    <v-col
      cols="12"
      :md="hasSyntheseAAfficher ? 12 : 8"
    >
      <RepartitionTresorerieDisponible
        :key="`treso-global-${dashboardKey}`"
        :annee-recolte-selected="anneeSelected"
        :code-graine-rs3-selected="codeGraineSelected"
      />
    </v-col>

    <v-col
      v-if="!hasSyntheseAAfficher"
      cols="12"
      md="4"
    >
      <SyntheseVide />
    </v-col>
  </v-row>
</template>

<script>
import RepartitionSurfaces from './repartition-surfaces.vue'
import RepartitionGrandesCultures from './repartition-grandes-cultures.vue'
import RepartitionMainOeuvre from './repartition-main-oeuvre.vue'
import RepartitionChiffreAffaires from './repartition-chiffre-affaires.vue'
import RepartitionChiffreAffairesParCulture from './repartition-chiffre-affaires-par-culture.vue'
import RepartitionTresorerieDisponible from './repartition-tresorerie-disponible.vue'
import Synthese from './synthese.vue'
import SyntheseVide from './synthese-vide.vue'
import { mapGetters } from 'vuex'

export default {
  name: 'BlocGlobal',
  components: {
    RepartitionTresorerieDisponible,
    RepartitionSurfaces,
    RepartitionChiffreAffairesParCulture,
    RepartitionGrandesCultures,
    RepartitionMainOeuvre,
    RepartitionChiffreAffaires,
    Synthese,
    SyntheseVide
  },
  props: {
    loading: {
      type: Object,
      default: () => ({
        grainesRs3: false,
        synthese: false
      })
    },
    hasSynthese: {
      type: Boolean,
      default: false
    },
    anneeSelected: {
      type: String,
      default: null
    },
    codeGraineSelected: {
      type: String,
      default: null
    },
    cultures: {
      type: Array,
      default: () => []
    },
    synthese: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    ...mapGetters({
      atelierCultureVerrouillage: 'cloture/atelierCultureVerrouillage'
    }),
    dashboardKey () {
      return `${this.anneeSelected}-${this.codeGraineSelected}`
    },
    hasClotureVerrouillee () {
      return this.atelierCultureVerrouillage != null && this.atelierCultureVerrouillage.isAtelierVerrouille
    },
    /**
     * Vérifie si le tableau de synthèse est vide, indéfini ou nul.
     * @returns {boolean} True si aucun élément n'est présent.
     */
    syntheseEmpty () {
      return !this.synthese || this.synthese.length === 0
    },
    /*
     * La synthèse ne se lit que sur une clôture verrouillée : elle commente des
     * chiffres arrêtés. Déverrouiller la clôture rouvre la saisie, les chiffres
     * commentés ne sont plus ceux affichés - la carte repasse donc à sa version
     * vide. Les faits marquants ne sont pas perdus pour autant : ils reviennent
     * au prochain verrouillage.
     */
    hasSyntheseAAfficher () {
      return !this.syntheseEmpty && this.hasClotureVerrouillee
    }
  }
}
</script>